import React from 'react';
import { useNavigate } from 'react-router-dom';

export const DLink = ({ to, children, style, className, target, replace = false, state }) => {
  const navigate = useNavigate();

  const handleClick = (e) => {
    if (!to) return;
    e.preventDefault();

    try {
      const isAbsolute = /^https?:\/\//i.test(to);

      if (!isAbsolute) {
        navigate(to, { replace, state });
        return;
      }

      const url = new URL(to);
      if (url.origin === window.location.origin) {
        navigate(url.pathname + url.search + url.hash, { replace, state });
        return;
      }

      if (target === '_blank') {
        window.open(to, '_blank', 'noopener,noreferrer');
      } else {
        window.location.assign(to);
      }
    } catch (err) {
      if (target === '_blank') {
        window.open(to, '_blank', 'noopener,noreferrer');
      } else {
        window.location.assign(to);
      }
    }
  };

  const combinedStyle = style ? { fontWeight: 'normal', ...style } : { fontWeight: 'normal' };

  return (
    <a href={to || '#'} onClick={handleClick} className={className} style={combinedStyle} target={target} rel={target === '_blank' ? 'noopener noreferrer' : undefined}>
      {children}
    </a>
  );
};

export default DLink;

